import { useProductFeatures } from "../hooks/useProductFeatures";
import { useFeatureFlagEnabled } from "posthog-js/react";

/**
 * Renders children if the feature flag is enabled. Either specify flag or flags depending on whether
 * you want to check for a single flag or multiple flags. Examples:
 *
 * <FeatureFlag flag="ms-staff">
 *   <div>This will be rendered if the ms-staff flag is enabled</div>
 * </FeatureFlag>
 *
 * <FeatureFlag flags={["ms-staff", "wbl-staff"]}>
 *   <div>This will be rendered if either the ms-staff or wbl-staff flags are enabled</div>
 * </FeatureFlag>
 *
 * <FeatureFlag flag="ms-staff" antiFlag="wbl-staff">
 *   <div>This will be rendered if the ms-staff flag is enabled but the wbl-staff flag is not</div>
 * </FeatureFlag>
 *
 * <FeatureFlag flags={["ms-staff", "wbl-staff"]} antiFlags={["ms-staff"]}>
 *   <div>This will be rendered if either the ms-staff or wbl-staff flags are enabled but the ms-staff flag is not</div>
 * </FeatureFlag>
 *
 */
export const FeatureFlag = ({
  flag = null,
  flags = [],
  antiFlag = null,
  antiFlags = [],
  children,
}) => {
  const { matchesProductPlans } = useProductFeatures();
  const matchesFlags = matchesProductPlans(flag ? [flag] : flags);
  const matchesAntiFlags = matchesProductPlans(
    antiFlag ? [antiFlag] : antiFlags,
  );
  return matchesFlags && !matchesAntiFlags ? children : null;
};

export const PosthogFeatureFlag = ({ flag, children }) => {
  const matchesFlags = useFeatureFlagEnabled(flag);
  return matchesFlags ? children : null;
};
